import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {DonationStore} from "../../../../../client/state/DonationStore";
import {DONATIONS_URL, SUBSCRIPTIONS_URL} from "../../../../Constants";
import {SubscriptionStore} from "../../../../../client/state/SubscriptionStore";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Flow} from "../../../initializeFlows";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {Router} from "../../../../../stem-core/src/ui/Router";


@autoredraw(PaymentMethodStore)
@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardCardInUsagePanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.irremovablePaymentMethodTitle,
        };
    }

    getDescription() {
        const {entries} = Flow.dashboard;
        const entry = entries[0];
        const descriptionSuffix = entries.length > 1 ? (
                entries.length > 2 ?
                    Messages.irremovablePaymentMethodDescription2c(entries.length - 1) :
                    Messages.irremovablePaymentMethodDescription2b(entries.length - 1)
            ) :
            Messages.irremovablePaymentMethodDescription2a;
        const paymentHref = entry.getStore() === DonationStore ? DONATIONS_URL
            : entry.getStore() === SubscriptionStore ? SUBSCRIPTIONS_URL : "";

        return [
            Messages.irremovablePaymentMethodDescription1,
            <Link href={`/${paymentHref}?focus="${entry.id}"`} value={entry.getMerchantTitle()} newTab
                  className={this.styleSheet.link}/>,
            descriptionSuffix
        ];
    }

    render() {
        return [
            <div>{this.getDescription()}</div>,
            <MerchantButton className={this.styleSheet.button} onClick={() => Router.back()}>
                {Messages.ok}
            </MerchantButton>
        ];
    }
}
